(function () {
  'use strict';

  var cartDrawer = document.getElementById('dxCartDrawer');
  var cartOverlay = document.getElementById('dxCartOverlay');
  var cartTrigger = document.getElementById('dxCartTrigger');
  var cartClose = document.getElementById('dxCartClose');
  var cartBody = document.getElementById('dxCartBody');
  var cartCount = document.getElementById('dxCartCount');
  var menuToggle = document.getElementById('dxMenuToggle');
  var navMobile = document.getElementById('dxNavMobile');

  function padCount(n) {
    return '[' + String(n).padStart(2, '0') + ']';
  }

  function openCart() {
    if (!cartDrawer) return;
    cartOverlay.hidden = false;
    requestAnimationFrame(function () {
      cartOverlay.classList.add('is-open');
      cartDrawer.classList.add('is-open');
    });
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartOverlay.classList.remove('is-open');
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { cartOverlay.hidden = true; }, 200);
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  if (menuToggle && navMobile) {
    menuToggle.addEventListener('click', function () {
      navMobile.hidden = !navMobile.hidden;
    });
  }

  // Cart mutations reload the page so the drawer re-renders server-side with
  // the fresh cart object. Simple and reliable; swap for section-rendering
  // (Ajax API `sections` param) later if you want it to update without a reload.
  function updateLineItem(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {});
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var item = e.target.closest('.dx-cart-item');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qtyEl = item.querySelector('.dx-qty-value');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);

      if (e.target.classList.contains('dx-qty-plus')) {
        updateLineItem(line, qty + 1);
      } else if (e.target.classList.contains('dx-qty-minus')) {
        updateLineItem(line, Math.max(0, qty - 1));
      } else if (e.target.classList.contains('dx-cart-item-remove')) {
        updateLineItem(line, 0);
      }
    });
  }

  // Ajax add-to-cart for any form[data-dx-add-to-cart]
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-dx-add-to-cart]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10)
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {})
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText; }
      });
  });
})();
